import React from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Calendar } from "primereact/calendar";

const EnquiryForm = ({ carDetail, handleSubmit, contactUsLoading, onSubmit, register, errors, timeOptions, systemSettings, setShowCalendar, showCalendar,
    setStartDate, setEndDate, startDate, endDate, fromTime, setFromTime, untilTime, setUntilTime
}:
    {
        carDetail: any, handleSubmit: any; contactUsLoading: boolean; onSubmit: any; register: any; errors: any, timeOptions: any, systemSettings: any
        setShowCalendar: any, showCalendar: boolean,
        setStartDate: any, setEndDate: any, startDate: Date | null, endDate: Date | null, fromTime: string, setFromTime: any, untilTime: string, setUntilTime: any

    }) => {



    return (
        <div
            className="modal new-modal fade check-availability-modal"
            id="enquiry"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content py-0" >

                    <form onSubmit={(e) => {

                        e.preventDefault();

                        handleSubmit(onSubmit)(e);
                    }} >
                        <div className="modal-header mb-0 pb-0 border-0">
                            <h6 className="mb-0 w-100 text-center fw-bold text-uppercase py-3">{carDetail?.vehicle_name ?? carDetail?.year_make_model}</h6>

                            <button
                                type="button"
                                className="close-btn"
                                data-bs-dismiss="modal"
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body mb-2">



                            <div className="row">
                                <div className="col-md-12 text-center mb-3">

                                    <div className="slider detail-bigimg">
                                        <div className="product-img" style={{
                                            objectFit: "cover",
                                            width: "100%",
                                            height: "200px",
                                            overflow: "hidden"
                                        }}  >
                                            <ImageWithBasePath src={carDetail?.vehicle_image ?? carDetail?.primary_image} alt={`Car Image`}

                                                height={"100%"}
                                                width={"100%"}

                                            // object-fit: cover;
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>



                            {carDetail?.vehicle_current_status === "Booked" && <div className="row">

                                <div className="col-md-12 mb-1">

                                    <div className="py-1">


                                        <div className="row">

                                            <div className="col-6">
                                                <Calendar
                                                    minDate={new Date()}
                                                    className="contact"
                                                    value={startDate}
                                                    onChange={(e) => {
                                                        const selectedDate = e.value as Date;

                                                        setStartDate(selectedDate);

                                                        if (selectedDate && systemSettings?.booking_min_duration) {
                                                            const duration = parseInt(systemSettings.booking_min_duration);
                                                            const calculatedEndDate = new Date(
                                                                new Date(selectedDate).setDate(selectedDate.getDate() + duration)
                                                            );
                                                            setEndDate(calculatedEndDate);
                                                        } else {
                                                            setEndDate(undefined);
                                                        }
                                                    }}// Ensure e.value is a Date
                                                    onHide={() => setShowCalendar(false)}
                                                    visible={showCalendar}

                                                />
                                            </div>
                                            <div className="col-6"> <select
                                                value={fromTime}
                                                onChange={(e) => {
                                                    setFromTime(e.target.value)
                                                }}
                                                className="form-select"
                                                style={{
                                                    border: "1px solid #d1d5db",
                                                    padding: "9px 15px"
                                                }}
                                            >
                                                {timeOptions?.map((time: any, index: string) => (
                                                    <option key={index} value={time}>
                                                        {time}
                                                    </option>
                                                ))}
                                            </select> </div>


                                        </div>
                                    </div>
                                    <div className="py-1">


                                        <div className="row">

                                            <div className="col-6">

                                                <Calendar
                                                    className="contact"
                                                    value={endDate} // Should be a Date object
                                                    minDate={
                                                        startDate && systemSettings?.booking_min_duration
                                                            ? new Date(
                                                                new Date(startDate).setDate(
                                                                    new Date(startDate).getDate() + parseInt(systemSettings.booking_min_duration)
                                                                )
                                                            )
                                                            : undefined
                                                    }
                                                    onChange={(e) => {
                                                        setEndDate(e.value);

                                                    }}
                                                    onHide={() => setShowCalendar(false)}
                                                    visible={showCalendar}

                                                />
                                            </div>
                                            <div className="col-6">
                                                <select
                                                    value={untilTime}
                                                    onChange={(e) => setUntilTime(e.target.value)}
                                                    className="form-select"

                                                    style={{
                                                        border: "1px solid #d1d5db",
                                                        padding: "9px 15px"
                                                    }}
                                                >
                                                    {timeOptions?.map((time: any, index: string) => (
                                                        <option key={index} value={time}>
                                                            {time}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>}

                            <div className="row">


                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="input-block">

                                                <input
                                                    type="text"
                                                    className={`contact form-control mb-0 py-2 ${errors.name ? "is-invalid" : ""}`}

                                                    placeholder="Name *"
                                                    {...register("name")}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className="input-block">

                                                <input
                                                    type="number"

                                                    className={`contact form-control mb-0 py-2 ${errors.phone ? "is-invalid" : ""}`}
                                                    placeholder="Mobile "
                                                    {...register("phone")}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="input-block">

                                                <input
                                                    type="text"
                                                    className={`contact form-control mb-0 py-2 ${errors.email ? "is-invalid" : ""}`}

                                                    placeholder="Email *"
                                                    {...register("email")}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="input-block">

                                                <textarea
                                                    className={`contact form-control mb-0 py-2 ${errors.message ? "is-invalid" : ""}`}
                                                    rows={4}
                                                    cols={50}
                                                    placeholder="Message *"
                                                    defaultValue={"\t\t\t\t\t\t\t\t\t\t\t"}
                                                    {...register("message")}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">

                                            <button
                                                type="submit" className="btn btn-primary w-100 py-1" disabled={contactUsLoading}>

                                                {contactUsLoading ? "Sending.." : carDetail?.vehicle_current_status === "Booked" ? "Check Availability" : "Get in touch"}

                                            </button>

                                        </div>

                                    </div>

                                </div>


                            </div>

                        </div>


                    </form>


                </div>
            </div>
        </div>
    );
};

export default EnquiryForm;

